/** Dropdown rows for Original Label, same shape moods/themes use: `{ name }`. */
export function normalizeMasterLabels(rows: unknown): { name: string }[] {
  if (!Array.isArray(rows)) {
    return [];
  }
  const seen = new Set<string>();
  const labels: { name: string }[] = [];
  for (const row of rows) {
    const name = labelNameOf(row);
    if (!name) continue;
    const key = name.toLowerCase();
    if (seen.has(key)) continue;
    seen.add(key);
    labels.push({ name });
  }
  labels.sort((a, b) => a.name.localeCompare(b.name, 'en', { sensitivity: 'base' }));
  return labels;
}

function labelNameOf(row: unknown): string {
  if (typeof row === 'string') {
    return row.trim();
  }
  if (!row || typeof row !== 'object') {
    return '';
  }
  const record = row as Record<string, unknown>;
  return String(record['name'] ?? record['title'] ?? record['label'] ?? '').trim();
}
